import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import theme from 'fe-appdir-lib-theme';
import { resetList } from 'fe-appdir-lib-utils';

const PROP_TYPES = {
  links: PropTypes.arrayOf(PropTypes.element),
  className: PropTypes.string.isRequired,
};
const DEFAULT_PROPS = {
  links: [],
};

const Buttons = styled.nav`
  font-size: ${theme.fontSizeSm};
`;

const ButtonsList = styled.ul`
  ${resetList};

  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 100%;
  margin-right: -${theme.spacingXs};
`;

const ButtonsItem = styled.li`
  margin: 0 4px;
`;

const AppButtons = ({ links, className }) => (
  <Buttons className={className}>
    <ButtonsList>
      {links.map((link, i) => (
        <ButtonsItem key={i}>{link}</ButtonsItem>
      ))}
    </ButtonsList>
  </Buttons>
);

AppButtons.propTypes = PROP_TYPES;
AppButtons.defaultProps = DEFAULT_PROPS;

export default AppButtons;
